var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-tabs",
          { attrs: { type: "border-card" } },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "SSR基础信息" } },
              [_c("ssr-manage-add")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "供应商Proposal" } },
              [_c("supplier-pane")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "报价信息PQCP" } },
              [_c("offer-info-pane")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "成本结构" } },
              [_c("cose-info-pane")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "产能信息" } },
              [_c("production-info-pane")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "物流能力" } },
              [_c("logistics-pane")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "SPM评分" } },
              [_c("spm-core-pane")],
              1
            ),
            _c("el-tab-pane", { attrs: { label: "状态变更日志" } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }